import { render, staticRenderFns } from "./PostAiGenerativeJob.vue?vue&type=template&id=f82ba5f8&scoped=true"
import script from "./PostAiGenerativeJob.vue?vue&type=script&lang=ts"
export * from "./PostAiGenerativeJob.vue?vue&type=script&lang=ts"
import style0 from "./PostAiGenerativeJob.vue?vue&type=style&index=0&id=f82ba5f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82ba5f8",
  null
  
)

export default component.exports